import requireAuthorization from "@/routes/helper/requireAuthorization";
import i18n from "@/i18n";
import { RoleEnum } from "@/store/authentication/types";

export default [
    {
        path: "/news",
        name: "news",
        component: () => import("@/components/news/_News.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            role: RoleEnum.InstancesRole,
            breadcrumbs: {
                icon: "profile-icon",
                paths: [
                    ["/news", i18n.t("news")]
                ]
            }
        }
    },
    {
        path: "/news/create/:newsType",
        name: "CreateNews",
        component: () => import("@/components/news/_NewsForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            role: RoleEnum.InstancesRole,
            breadcrumbs: {
                icon: "profile-icon",
                paths: [
                    ["/news/create", i18n.t("news.title")]
                ]
            }
        },
        props: true
    },
    {
        path: "/news/update/:newsType/:id",
        name: "UpdateNews",
        component: () => import("@/components/news/_NewsForm.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            role: RoleEnum.InstancesRole,
            breadcrumbs: {
                icon: "profile-icon",
                paths: [
                    ["/news/update/:newsType/:id", i18n.t("news.title")]
                ]
            }
        },
        props: true
    }
];
